<template>
  <div id="feature-detail-body">
    <div class="feature-nav">
      <div class="feature-nav-content">
        <a-breadcrumb>
          <a-breadcrumb-item>
            <router-link to="/search">项目</router-link>
          </a-breadcrumb-item>
          <a-breadcrumb-item><router-link to="/project-feature">需求列表</router-link></a-breadcrumb-item>
          <a-breadcrumb-item>需求详情</a-breadcrumb-item>
        </a-breadcrumb>
      </div>
    </div>
    <div class="feature-head">
      <div class="feature-head-content">
        <p class="feature-head-title">{{featurDetailObj.title}}</p>
        <div class="feature-head-tags">
          <span v-for="(tag,index) in featurDetailObj.tags" :key="index">{{tag.name}}</span>
        </div>
        <p class="feature-head-desc">{{featurDetailObj.desc}}</p>
        <div class="feature-head-info">
          <img alt="" :src="featurDetailObj.author_icon" class="feature-info-author-icon">
          <span class="feature-head-author">{{featurDetailObj.author}}/{{featurDetailObj.companyName}}</span>
          <span class="feature-head-span">源代码</span>
          <img alt="" class="feature-source-icon" src="./../assets/link.png" />
          <span class="feature-source-url">{{featurDetailObj.source_code}}</span>
          <span class="feature-head-date">{{featurDetailObj.create_time}}</span>
        </div>
        <div class="feature-head-num">
          <a-icon type="eye" />
          <span class="watch-num">{{featurDetailObj.watch_num}}</span>
          <a-icon class="like-num" type="like" />
          <span >{{featurDetailObj.like_num}}</span>
          <a-icon class="comment-num" type="message" />
          <span >{{featurDetailObj.comment_num}}</span>
        </div>
      </div>
    </div>
    <div class="feature-comment-list">
      <div class="feature-comment-content">
        <div class="comment-list-item" v-for="(comment,index) in featurDetailObj.comments" :key="index">
          <div class="list-item-top">
            <img alt="" :src="comment.user_icon" class="list-item-img">
            <span class="list-item-author">{{comment.user_name}}/{{comment.user_company}}</span>
            <span class="list-item-date">{{comment.create_time}}</span>
          </div>
          <p class="list-item-content">{{comment.content}}</p>
        </div>
        <p class="comment-length">{{featurDetailObj.comments.length}}个留言&nbsp;&nbsp;&nbsp;共1页</p>
      </div>
      <a-divider></a-divider>
      <p class="comment-tip">发表留言</p>
      <div class="comment-login-tip" v-if="!isLogin">
        <a-icon type="exclamation-circle" />
        请先登录后再发表留言
        <span><router-link to="/">点击登录</router-link></span>
      </div>
      <div class="comment-block">
        <a-input v-model="comment" type="textarea" placeholder="请输入您的评论内容"></a-input>
      </div>

      <div class="comment-btn">
        <a-button v-if="!isLogin">登录</a-button>
        <a-button v-if="isLogin">发表</a-button>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "feature-detail",
    data() {
      return {
        comment:'',
        isLogin:false,
        featurDetailObj:{
          title:'这是一条简洁描述的项目需求',
          tags:[
            {
              id:1,
              name:'社交',
            },
            {
              id:2,
              name:'财务',
            },
            {
              id:3,
              name:'游戏',
            }
          ],
          desc:'品牌也远不是强调名称，标志，符号或者商标。它融合了一系列定义其形象的独特价值，并作为一份不成文的合同，通过在消费者每一次购买，使用，体验是提供始终如一的产品和服务。同时还在寻求与消费者的情感联系，确保终身关系',
          author:'James',
          author_icon:require('./../assets/hm-logo.png'),
          companyName: '北京毫末科技',
          source_code:'https://github.com/',
          create_time:'2020-04-20 18:00',
          watch_num:100,
          like_num:93,
          comment_num:39,
          comments:[
            {
              user_icon:require('./../assets/hm-logo.png'),
              user_name:'张三',
              user_company:'深圳毫末科技有限公司',
              create_time:'2020-04-08 15:29',
              content:'我认为，大多数设计师只是试图从他们已经做过的事情中努力，在讲故事方面并没有什么特别之处，而我的回归，将伴随着一个伟大的演讲'
            },
            {
              user_icon:require('./../assets/hm-logo.png'),
              user_name:'张三',
              user_company:'深圳毫末科技有限公司',
              create_time:'2020-04-08 15:29',
              content:'我认为，大多数设计师只是试图从他们已经做过的事情中努力，在讲故事方面并没有什么特别之处，而我的回归，将伴随着一个伟大的演讲'
            },{
              user_icon:require('./../assets/hm-logo.png'),
              user_name:'张三',
              user_company:'深圳毫末科技有限公司',
              create_time:'2020-04-08 15:29',
              content:'我认为，大多数设计师只是试图从他们已经做过的事情中努力，在讲故事方面并没有什么特别之处，而我的回归，将伴随着一个伟大的演讲'
            }
          ]
        }
      }
    }
  }
</script>

<style lang="less" scoped>
  #feature-detail-body {
    background-color: #F5F5F5;

    .feature-nav {
      width: 100%;
      background-color: #fff;
      height: 60px;
      line-height: 60px;
      margin-bottom: 15px;
      text-align: left;
      .feature-nav-content {
        width: 1400px;
        margin: 0 auto;
        height: 60px;
        line-height: 60px;
      }
    }
    .feature-head {
      width: 100%;
      min-height: 260px ;
      background-color: #fff;
      .feature-head-content {
        width: 1400px;
        margin: 0 auto;
        text-align: left;
        .feature-head-title {         
          font-size: 20px;
          color: #333333;
          padding-top: 30px;
        }
        .feature-head-tags span {
          background: #F5F5F5;
          border: 1px solid #D9D9D9;
          border-radius: 4px;
          padding: 3px 5px;
          margin-left: 5px;
        }
        .feature-head-desc {         
          font-size: 14px;
          color: #333333;
          margin-top: 10px;
        }
        .feature-head-info {
          .feature-info-author-icon {
            width: 26.6px;
            height: 26.6px;
          }
          .feature-head-author {
            margin-left: 5px;   
            font-size: 14px;
            color: #333333;
            text-align: justify;
          }
          .feature-head-span {       
            font-size: 14px;
            color: #666666;
            text-align: justify;
            margin-left: 5px;
          }
          .feature-source-icon {
            width: 10px;
            height: 10px;
            margin-left: 5px;
          }
          .feature-source-url {         
            font-size: 14px;
            color: #528EC9;
            text-align: justify;
            margin-left: 5px;
          }
          .feature-head-date {    
            font-size: 14px;
            color: rgba(0,0,0,0.25);
            margin-left: 35px;
          }
        }
        .feature-head-num {
          color: rgba(0,0,0,0.45);
          font-size: 14px;
          line-height: 40px;
          .like-num {
            margin-left: 10px;
          }
          .comment-num {
            margin-left: 10px;
          }
        }
      }
    }
    .feature-comment-list {
      width: 1515px;
      min-height: 700px;
      background-color: #fff;
      margin: 0 auto;
      margin-top: 30px;
      padding-bottom: 100px;
      .feature-comment-content {
        width: 1400px;
        margin: 0 auto;
        .comment-list-item {
          height: 96px;
          border-bottom: 1px solid #e9e9e9;
          text-align: left;
          .list-item-top {
            line-height: 40px;
            padding-top: 20px;
            .list-item-img {
              width: 26.6px;
              height: 26.6px;
            }
            .list-item-author {         
              font-size: 14px;
              color: #666666;
              text-align: justify;
              margin-left: 10px;
            }
            .list-item-date {       
              font-size: 14px;
              color: rgba(0,0,0,0.25);
              margin-left: 30px;
            }
            .list-item-content {         
              font-size: 14px;
              color: #333333;
            }
          }
        }
        .comment-length {        
          font-size: 12px;
          color: rgba(0,0,0,0.25);
          text-align: left;
          margin-top: 20px;
        }
      }
      .comment-tip {      
        font-size: 16px;
        color: #333333;
        text-align: left;
        font-weight: 500;
        margin-left: 50px;
        margin-top: 20px;
      }
      .comment-login-tip {
        width: 1315px;
        height: 52px;
        margin: 0 auto;
        line-height: 52px;
        background: rgba(250,73,60,0.06);
        border: 1px solid #D9D9D9;
        border-radius: 4px;
        letter-spacing: 1.5px;
        span,a {
          color: #FD4734;
          font-weight: 500;
          margin-left: 10px;
        }
      }
      .comment-block {
        width: 1315px;
        height: 237px;
        margin: 0 auto;
        background: #F5F5F5;
        border: 1px solid #D9D9D9;
        border-radius: 4px;
        margin-top: 20px;
      }

      .comment-btn button {
        background-color: #FD4734;
        color: #fff;
        border-color: #FD4734;
        width: 150px;
        margin-top: 50px;
      }
    }
  }
  /deep/ .ant-breadcrumb {
    height: 60px;
    line-height: 60px;
  }
  /deep/ textarea.ant-input {
    width: 1251px;
    height: 186px;
    margin-top: 25px;
  }
</style>
